/**
 * A cover's name as a song title: covers are often named after the upload
 * ("Song (Lyric Video)(MP3_160K) · RaceCut.mp3"), so drop the extension,
 * bracketed asides and anything after a "·" or "|".
 */
export function songTitle(name: string): string {
  const clean = name
    .replace(/\.(mp3|wav|m4a|flac|ogg|mp4)$/i, "")
    .split(/\s[·|]\s/)[0]
    .replace(/\s*[([{][^)\]}]*[)\]}]/g, "")
    .replace(/_/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
  return clean || name;
}

/**
 * The song title when it reads like one, else null. Many covers are named
 * after a recording or a prompt ("IMG_0382.mp3", "Recording_2026-09-08…",
 * 'TTS: "Ooh!…"', "Generate:softmodernpop…"), which shouldn't be shown back
 * to people as the name of their song.
 */
export function readableTitle(name: string | null | undefined): string | null {
  if (!name) return null;
  if (/^(tts|generate)\s*:/i.test(name.trim())) return null;
  const t = songTitle(name);
  if (
    t.length > 40 ||
    /\d{4,}/.test(t) ||
    /^(img|vid|recording|audio|voice|new recording)\b/i.test(t) ||
    /\.\w{2,4}$/.test(t)
  )
    return null;
  return t;
}

/**
 * A voice's name without the detail after it: "Daffy Duck (Jeff Bergman)",
 * "Squidward V2.1".
 */
export const voiceName = (name: string | null | undefined) =>
  (name || "")
    .replace(/\s*\([^)]*\)\s*$/, "")
    .replace(/\s+v\d+(\.\d+)*$/i, "")
    .trim();
